const skills = [
	{
		key: 'p1',
		title: 'Frontend',
		list: [
			'React.js',
			'Next.js',
			'React Native',
			'JavaScript',
			'CSS',
			'HTML',
			'Sass',
		],
	},
	{
		key: 'p2',
		title: 'Design',
		list: ['Figma', 'Adobe XD'],
	},
	{
		key: 'p3',
		title: 'Backend',
		list: ['JavaScript', 'Node.js'],
	},
	{
		key: 'p4',
		title: 'Others',
		list: [
			'TypeScript',
			'GraphQL',
			'Firebase',
			'AWS',
		],
	},
];

export default skills;
